import { useSelector } from 'react-redux';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { isRussianBlockedSelector } from '../../selectors/PurchaseMotionSelectors';
import RussianBlockedBanner from './RussianBlockedBanner';
import { jsx as _jsx } from "react/jsx-runtime";
const BannerHierarchySection = () => {
  const isAppReady = useGlobalLoading();
  const isRussianBlocked = useSelector(isRussianBlockedSelector);
  if (!isAppReady) {
    return null;
  }
  if (isRussianBlocked) {
    return /*#__PURE__*/_jsx(RussianBlockedBanner, {});
  }
  return null;
};
export default BannerHierarchySection;